export { ListadosPT } from "./pages/ListadosPT";

export { CreacionPT } from "./pages/CreacionPT";